'use client'

import { ReactNode, useEffect, useRef, useState } from 'react'
import styles from './CustomScrollbar.module.scss'

export default function CustomScrollbar({ children }: { children: ReactNode }) {
  const containerRef = useRef(null)

  const [thumbHeight, setThumbHeight] = useState(0)
  const [thumbTop, setThumbTop] = useState(0)

  const updateScrollbar = () => {
    const el = containerRef.current
    if (!el) return

    const { scrollTop, scrollHeight, clientHeight } = el

    const height = Math.max((clientHeight / scrollHeight) * clientHeight, 30)

    const top = (scrollTop / (scrollHeight - clientHeight)) * (clientHeight - height)

    setThumbHeight(height)
    setThumbTop(top)
  }

  useEffect(() => {
    updateScrollbar()

    const el: any = containerRef.current

    el.addEventListener('scroll', updateScrollbar)
    window.addEventListener('resize', updateScrollbar)

    return () => {
      el.removeEventListener('scroll', updateScrollbar)
      window.removeEventListener('resize', updateScrollbar)
    }
  }, [])

  return (
    <div className={styles['scroll-wrapper']}>
      <div ref={containerRef} className={styles['scroll-content']}>
        {children}
      </div>

      <div className={styles['scroll-track']}>
        <div
          className={styles['scroll-thumb']}
          style={{
            height: thumbHeight,
            transform: `translateY(${thumbTop}px)`,
          }}
        />
      </div>
    </div>
  )
}
